import React, { useState, useEffect } from 'react';
import { Box, Typography, CircularProgress, Card, CardContent, Grid, Paper } from '@mui/material';

// Function to determine the color for the risk value
const getRiskColor = (value) => {
    switch (value) {
        case 0: return 'gray';
        case 1: return '#fcd34d'; // yellow-300
        case 2: return '#eab308'; // yellow-500
        case 3: return '#f97316'; // orange-500
        case 4: return '#dc2626'; // red-600
        case 5: return '#7f1d1d'; // red-900
        default: return 'gray';
    }
};

const toSentenceCase = (str) => {
  if (str === null || str === '') {
    return '';
  }
  str = str.toLowerCase();
  return str.charAt(0).toUpperCase() + str.slice(1);
}

const VegetationFuel = ({ codeLocation }) => {
    const [data, setData] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    // This useEffect hook runs when the component mounts or when 'codeLocation' changes
    useEffect(() => {
        const fetchData = async () => {
            if (!codeLocation) {
                setError('No "codeLocation" prop provided.');
                setLoading(false);
                return;
            }

            const dataPath = `https://content.firerebuild.com/data/fveg/risk/${codeLocation}.json?00001`;
            setLoading(true); // Set loading to true for each new fetch

            try {
                const response = await fetch(dataPath);
                if (!response.ok) {
                    throw new Error(`HTTP error! status: ${response.status}`);
                }
                const jsonData = await response.json();
                setData(jsonData);
            } catch (err) {
                console.error('Could not load data:', err);
                setError(`Failed to load data. Please ensure the file exists at: ${dataPath}`);
            } finally {
                setLoading(false);
            }
        };

        fetchData();
    }, [codeLocation]);

    const renderContent = () => {
        if (loading) {
            return (
                <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '200px' }}>
                    <CircularProgress />
                    <Typography variant="h6" sx={{ ml: 2 }}>
                        Loading data...
                    </Typography>
                </Box>
            );
        }

        if (error) {
            return (
                <Box sx={{ textAlign: 'center', color: 'error.main', mt: 4 }}>
                    <Typography variant="body1" fontWeight="bold">
                        {error}
                    </Typography>
                </Box>
            );
        }

        if (!data || data.length === 0) {
            return (
                <Box sx={{ textAlign: 'center', color: 'text.secondary', mt: 4 }}>
                    <Typography variant="h6">No data available.</Typography>
                </Box>
            );
        }

        return (
            <Grid container spacing={4}>
                {data.map((item, index) => (
                    <Grid item xs={12} sm={6} md={6} key={index} sx={{ width: '100%' }}>
                        <Card
                            component={Paper}
                            elevation={3}
                            sx={{
                                height: '100%',
                                display: 'flex',
                                flexDirection: 'column',
                                transition: 'transform 0.2s',
                                '&:hover': {
                                    transform: 'scale(1.01)',
                                },
                            }}
                        >
                            <CardContent sx={{ display: 'flex', flexDirection: 'column', height: '100%', width: '100%', boxSizing: 'border-box' }}>
                                <Box>
                                    <Box sx={{ display: 'flex', flexDirection: { xs: 'column', sm: 'row' }, alignItems: { sm: 'center' }, justifyContent: 'space-between', width: '100%' }}>
                                        <Typography variant="h5" component="h2" fontWeight="bold" sx={{ mb: { xs: 1, sm: 0 } }}>
                                            {toSentenceCase(item.category)}: {item.name}
                                        </Typography>
                                        <Typography variant="h6" color="text.secondary" sx={{ flexShrink: 0 }}>
                                            Distance: {item.miles} miles
                                        </Typography>
                                    </Box>
                                    <Typography variant="body2" color="text.secondary" sx={{ mt: 1, overflowWrap: 'break-word' }}>
                                        {item.desc}
                                    </Typography>
                                </Box>
                                <Box sx={{ mt: 'auto', pt: 2, borderTop: 1, borderColor: 'divider', display: 'flex', alignItems: 'center', spacing: 2 }}>
                                    <Box
                                    sx={{
                                        width: 24,
                                        height: 24,
                                        borderRadius: '50%',
                                        backgroundColor: getRiskColor(item.value),
                                        mr: 2,
                                        flexShrink: 0,
                                        boxSizing: 'border-box',
                                    }} />
                                    <Typography variant="body2" color="text.primary" sx={{ display: 'flex', alignItems: 'center' }}>
                                        Risk: {item.risk}
                                    </Typography>
                                </Box>
                            </CardContent>
                        </Card>
                    </Grid>
                ))}
            </Grid>
        );
    };

    return (
        <Box sx={{ p: { xs: 2, sm: 4 }, maxWidth: 1200, mx: 'auto', my: 4 }}>
            {renderContent()}
        </Box>
    );
};

export default VegetationFuel;

/*
            <Grid container spacing={4}>
                {data.map((item, index) => (
                    <Grid item xs={12} sm={6} md={6} key={index}>
                        <Card
                            component={Paper}
                            elevation={3}
                            sx={{
                                transition: 'transform 0.2s',
                                '&:hover': {
                                    transform: 'scale(1.01)',
                                },
                            }}
                        >
                            <CardContent sx={{ display: 'flex', flexDirection: 'column', height: '100%', width: '1000px' }}>
                                <Box>
                                    <Box sx={{ display: 'flex', flexDirection: { xs: 'column', sm: 'row' }, alignItems: { sm: 'center' }, justifyContent: 'space-between', width: '100%' }}>
                                        <Typography variant="h5" component="h2" fontWeight="bold" sx={{ mb: { xs: 1, sm: 0 } }}>
                                            {toSentenceCase(item.category)}: {item.name}
                                        </Typography>
                                        <Typography variant="h6" color="text.secondary" sx={{ flexShrink: 0 }}>
                                            Distance: {item.miles} miles
                                        </Typography>
                                    </Box>
                                    <Typography variant="body2" color="text.secondary" sx={{ mt: 1, overflowWrap: 'break-word' }}>
                                        {item.desc}
                                    </Typography>
                                </Box>
                                <Box sx={{ mt: 'auto', pt: 2, borderTop: 1, borderColor: 'divider', display: 'flex', alignItems: 'center', spacing: 2 }}>
                                    <Box sx={{ width: 24, height: 24, borderRadius: '50%', backgroundColor: getRiskColor(item.value), mr: 2 }} />
                                    <Typography variant="body2" color="text.primary" sx={{ display: 'flex', alignItems: 'center' }}>
                                        Risk: {item.risk}
                                    </Typography>
                                </Box>
                            </CardContent>
                        </Card>
                    </Grid>
                ))}
            </Grid>
*/